import AddTaskIcon from "@mui/icons-material/AddTask";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { FormHelperText, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState } from "react";
import {
  USERS_URL,
  TASKS_URL,
  IMPACTS_URL,
  TICKET_ALL_URL,
} from "../../Constants/Constants";
import { STATUS_OPEN_ID } from "../../Constants/StatusConstants";
import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { useAlert } from "./../alerts//AlertContext";
import { hasRole } from "../../auth/authService";
import { ROLE_ADMIN } from "../../Constants/RolesConstants";
import Grid from "@mui/material/Grid2";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, parseISO } from "date-fns";

function TaskDialog({ callTasks, openDialog,
  onClose }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [due, setDue] = useState(null);
  const [assignee, setAssignee] = useState("");
  const [assignees, setAssignees] = useState([]);

  const [priority, setPriority] = useState("");
  const [priorities, setPriorities] = useState([]);

  const [ticket, setTicket] = useState("");
  const [tickets, setTickets] = useState([]);

  const [error, setError] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    //due: "",
    assignee: "",
    priority: "",
    //ticket: ""
  });

  const [formErrors, setFormErrors] = useState({
    title: "",
    description: "",
    //due: "",
    assignee: "",
    priority: "",
    //ticket: ""
  });

  const [task, setTask] = useState({
    title: "",
    description: "",
    due: "",
    assignee: {},
    priority: {},
    status: {},
    ticket: {},
  });

  const [open, setOpen] = useState(false);

  const handleFormData = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.title.trim()) errors.title = "Title is required";
    if (!formData.description.trim())
      errors.description = "Description is required";
    //if (!formData.due) errors.due = "Due Date is required";
    if (!formData.assignee) errors.assignee = "Assignee is required";

    if (!formData.priority) errors.priority = "Priority is required";

    return errors;
  };

  useEffect(() => {
    if (openDialog) {
      setOpen(true);
      initializeSysValues();
    }
  }, [openDialog]);

  const showAlert = useAlert();

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleClickOpen = () => {
    setOpen(true);
    initializeSysValues();
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
    handleFormData(event);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    handleFormData(event);
  };

  const handleAssigneeChange = (event) => {
    setAssignee(event.target.value);
    handleFormData(event);
  };

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
    handleFormData(event);
  };

  const handleTicketChange = (event) => {
    setTicket(event.target.value);
    //handleFormData(event);
  };

  const handleDueDateChange = (date) => {
    // const isoDate = date ? format(date, "yyyy-MM-dd") : null;
    // console.log("Selected Date:", date);
    setDue(date);
  };

  const initializeSysValues = () => {
    AxiosInstance.get(IMPACTS_URL).then((response) =>
      setPriorities(response.data)
    );

    AxiosInstance.get(USERS_URL).then((response) =>
      setAssignees(response.data.data)
    );

    AxiosInstance.get(TICKET_ALL_URL).then((response) =>
      setTickets(response.data)
    );
  };
  const saveTask = () => {
    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      setError(false);
      var palyload = {};
      palyload.title = title;
      palyload.description = description;
      palyload.due = due;
      palyload.assignee = { id: assignee };
      palyload.priority = { id: priority };
      palyload.status = { id: STATUS_OPEN_ID };
      palyload.ticket = { id: ticket };

      AxiosInstance.post(TASKS_URL, palyload)
        .then((response) => {
          showAlert("Task created successfully!", "success");
          callTasks();
        })
        .catch((error) => {
          showAlert("Task creation failed!", "error");
          console.error(error);
        });
      handleClose();
    }
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        <Tooltip
          title="Add Task"
          onClick={handleClickOpen}
          style={{ cursor: "pointer", margin: "2px" }}
        >
          <IconButton>
            <AddTaskIcon color="primary" />
          </IconButton>
        </Tooltip>

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              saveTask();
            },
            sx: {
              width: 800, // fixed width
              height: 500, // fixed height
              maxWidth: "100%", // optional for responsiveness
              maxHeight: "100%", // optional to prevent overflow
            },

          }}
        >
          <DialogTitle>Add Task</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiTextField-root": { m: 1, width: "95%" } }}
              noValidate
              autoComplete="off"
            >
              {/* Title */}
              <TextField
                autoFocus
                fullWidth
                required
                margin="dense"
                id="outlined-multiline-static"
                name="title"
                label="Title"
                type="text"
                variant="outlined"
                value={formData.title}
                error={!!formErrors.title}
                helperText={formErrors.title}
                onChange={handleTitleChange}
              />
              <br />
              {/* Description */}
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="description"
                label="Description"
                placeholder="Description"
                fullWidth
                multiline
                rows={4}
                cols={10}
                required
                value={formData.description}
                error={!!formErrors.description}
                helperText={formErrors.description}
                onChange={handleDescriptionChange}
              />
              <br />
              {/* Assignee */}
              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "47%" }}
                required
                error={Boolean(formErrors.assignee)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Assignee
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="assignee"
                  // value={requestTypeId}
                  value={formData.assignee}
                  onChange={handleAssigneeChange}
                  label="Assignee"
                >
                  {assignees.map((as) => (
                    <MenuItem value={as.id}>{as.name}</MenuItem>
                  ))}
                </Select>
                {error && (
                  <FormHelperText>{formErrors.assignee}</FormHelperText>
                )}
              </FormControl>
              {/* Due Date */}
              <FormControl
                variant="outlined"
                required
                error={Boolean(formErrors.priority)}
                sx={{ minWidth: "48%" }}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={due}
                    onChange={handleDueDateChange}
                    label="Due Date"
                    views={["year", "month", "day"]}
                  />
                </LocalizationProvider>
              </FormControl>
              <br />
              {/* Priority */}
              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "47%" }}
                required
                error={Boolean(formErrors.priority)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Priority
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="priority"
                  //value={categoryId}
                  value={formData.priority}
                  onChange={handlePriorityChange}
                  label="Priority"
                >
                  {priorities.map((pr) => (
                    <MenuItem value={pr.id}>{pr.name}</MenuItem>
                  ))}
                </Select>
                {error && (
                  <FormHelperText>{formErrors.priority}</FormHelperText>
                )}
              </FormControl>
              {/* Ticket */}
              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "46%" }}
                error={Boolean(formErrors.ticket)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Ticket
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="ticket"
                  value={formData.ticket}
                  onChange={handleTicketChange}
                  label="Ticket"
                >
                  {tickets.map((tkt) => (
                    <MenuItem value={tkt.id}>{tkt.id}</MenuItem>
                  ))}
                </Select>
                {error && <FormHelperText>{formErrors.ticket}</FormHelperText>}
              </FormControl>
              <br />
            </Box>
          </DialogContent>
          <DialogActions
            sx={{ paddingRight: 3, marginBottom: "20px" }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              startIcon={<CancelIcon />}
              sx={{
                float: "right",
                minWidth: 150,
                marginRight: "25px",
                marginTop: "10px",
                // background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
                "&:hover": {
                  background: "invert(1)",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              startIcon={<SaveIcon />}
              sx={{
                float: "right",
                minWidth: 150,
                marginRight: "25px",
                marginTop: "10px",
                background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
                "&:hover": {
                  background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
                },
              }}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default TaskDialog;
